import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik'
import { generateFileUrl } from '../../apiHelper';

import * as constants from './constants';

import { RatingResponseSchema } from './validation';
import { USER_PLACEHOLDER } from '../../constants/images';

class ReviewComponent extends Component {
  constructor(props) {
    super(props);
  }

  renderStarValue(value) {
    let valueDom = []
    for (let i = 0; i < 5; i++) {
      if (value - i >= 1) { valueDom.push(<i key={`star_${i}`} className="fas fa-star" />); }
      else if (value - i >= .3) { valueDom.push(<i key={`star_${i}`} className="fas fa-star-half-alt" />); }
      else { valueDom.push(<i key={`star_${i}`} className="far fa-star" />); }
    }
    return (<div>{valueDom}</div>);
  }

  renderReviewValue(review) {
    let descriptions = this.props.type === 'owner'
      ? constants.REVIEW_LISTING_TYPES : constants.REVIEW_USER_TYPES;
    return (<div className="w-100 text-center">
      {review.values.map((v, i) => {
        return (<div key={`review_${i}`} className="row">
          <div className="col-7 text-left p-0"><strong>{descriptions[i]}:</strong> {v}/5</div>
          <div className="col-5">{this.renderStarValue(v)}</div></div>);
      })}
    </div>)
  }

  renderResponseForm(reviewId, onSubmit) {
    return (
      <Formik onSubmit={(values, other) => {
        onSubmit(values, other);
        other.resetForm();
      }}
        initialValues={{
          reviewId: reviewId,
          response: ''
        }}
        validationSchema={RatingResponseSchema}>
        <Form id={`${reviewId}_response`}>
          <div className="row mt-0 pt-0">
            <div className="col-lg-5">
              <Field
                type="hidden"
                name="reviewId"
                value={reviewId} />
            </div>
            <div className="col-lg-5 col-md-10 p-1">
              <Field
                name="response"
                component="textarea"
                placeholder="Leave a response"
                className="form-control" />
            </div>
            <div className="col-lg-2 p-1">
              <button type="submit">Send</button>
            </div>
          </div>
        </Form>
      </Formik>);
  }

  render() {
    let { review, onSubmit } = this.props;
    if (!review) return (<div />);
    let reviewAverage = (review.values.reduce((total, num) => { return total + num; }) / review.values.length).toFixed(1);

    const imgPath = review.reviewingUser && review.reviewingUser.profile && review.reviewingUser.profile.photo ?
      generateFileUrl(review.reviewingUser.profile.photo, review.reviewingUser._id) : USER_PLACEHOLDER;

    return (<div className="user-review-container">
      <div className="row user-review-header p-2">
        <div className="col d-flex align-center">
          <div className="profile-photo-tiny">
            <img src={imgPath} />
          </div>
          <div className="mt-auto mb-auto"><h5>{review.reviewingUser.firstName} {review.reviewingUser.lastName.substr(0, 1)}.</h5></div></div>
        <div className="col text-center">
          <div className="d-inline-block mt-3 pr-2">{this.renderStarValue(reviewAverage)}</div><div className="d-inline-block">(overall rating {reviewAverage})</div>
        </div>
      </div>
      <div className="row user-review-content">
        <div className="col-lg-5 d-flex align-center">
          {this.renderReviewValue(review)}
        </div>
        <div className="col-lg-7">
          {review.message ? review.message : "No additional comments."}
        </div>
      </div>
      {this.props.showReviewResponseForm && !review.response && this.renderResponseForm(review._id, onSubmit)}
      {!!review.response && !!this.props.responderName ? (
        <div className="row user-review-response">
          <div className="w-100">
            <div className="row"><strong>{this.props.responderName} Responded:</strong>&nbsp;{review.response}</div>
          </div>
        </div>
      ) : null}
    </div>);
  }
}

export default ReviewComponent;
